import React from 'react'
import Button from './Button'

const ButtonSignin = (props) => {
  return (
    <Button
      color="bar"
      icon="PersonAdd"
      {...props}
    />
  )
}

export default ButtonSignin
